// Signing in (AuthModal → /dashboard, Google → /auth/callback/complete) would
// lose an OAuth consent request in progress (MCP connector). The consent page
// remembers itself here before the user signs in, and the sign-in flows send
// the user back once the session exists. Ported from SimpleStickers.

const STORAGE_KEY = 'oauthConsentReturn'
const MAX_AGE_MS = 15 * 60 * 1000

export function saveConsentReturn(url: string) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ url, at: Date.now() }))
  } catch {
    // storage unavailable: email/password sign-in still reloads the consent page
  }
}

// Returns the consent URL to go back to (and forgets it), if one is pending.
// Only relative /oauth/consent URLs are accepted (no open redirect).
// onlyOnConsentPage: AuthModal signs in in place, so an entry left behind by
// an abandoned consent must not redirect a later sign-in elsewhere in the tab.
export function takeConsentReturn({ onlyOnConsentPage = false } = {}): string | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    sessionStorage.removeItem(STORAGE_KEY)
    if (onlyOnConsentPage && window.location.pathname !== '/oauth/consent') return null
    const { url, at } = JSON.parse(raw) as { url?: string; at?: number }
    if (typeof url !== 'string' || !url.startsWith('/oauth/consent?')) return null
    if (typeof at !== 'number' || Date.now() - at > MAX_AGE_MS) return null
    return url
  } catch {
    return null
  }
}
